import { ALLOWED_SPACES_THREAD_PERMISSIONS } from '#pplx/frontend/apps/ask/hooks/collections-hooks/collection-mutations/constants.js';
import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
import { useArticleResults } from '#pplx/frontend/apps/ask/providers/ArticleResultsProviderShared.js';
import { useRWToken } from '#pplx/frontend/apps/ask/providers/hooks/useRWToken.js';
import { useMutateResults } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { AccessLevel } from '#pplx/frontend/components/types/types.js';
import { MessageHelper } from '#pplx/frontend/components/utils/MessageHelper.js';
import { useCallback } from 'react';
export const usePrivatizeThreadIfEnterprise = ({ reason, }) => {
    const { isEnterprise } = useUserOrgData({ reason });
    const { threadMetadata: articleThreadMetadata } = useArticleResults();
    const rwToken = useRWToken();
    const mutateResults = useMutateResults();
    // TODO: Better way to do this? Invalidating query doesn't refetch.
    // This updates frontend UI based on assumed backend access update.
    const privatizeThreadIfEnterprise = useCallback((action) => {
        // FIXME - ModalProvider is outside ArticleResultsProvider so we can't
        // see thread metadata when we add or swap thread/page collections
        const isReadyOnly = !rwToken && !articleThreadMetadata?.rwToken;
        // Normal user or read-only thread won't change access level
        if (!isEnterprise || isReadyOnly) {
            return;
        }
        mutateResults((oldThread) => {
            if (!oldThread) {
                return;
            }
            return oldThread.map((message) => {
                let hasAllowedAccess = false;
                let fallbackAccess = AccessLevel.PRIVATE_READ;
                if (action === 'add') {
                    hasAllowedAccess = ALLOWED_SPACES_THREAD_PERMISSIONS.includes(message.thread_access ?? null);
                    fallbackAccess = MessageHelper.isArticleMode(message)
                        ? AccessLevel.PRIVATE_READ
                        : AccessLevel.COLLECTION_READ;
                }
                else {
                    hasAllowedAccess = message.thread_access !== AccessLevel.COLLECTION_READ;
                    fallbackAccess = AccessLevel.PRIVATE_READ;
                }
                return {
                    ...message,
                    thread_access: hasAllowedAccess ? message.thread_access : fallbackAccess,
                };
            });
        });
    }, [rwToken, articleThreadMetadata?.rwToken, isEnterprise, mutateResults]);
    return privatizeThreadIfEnterprise;
};
//# sourceMappingURL=usePrivatizeThreadIfEnterprise.js.map